
import { Vue } from "vue-class-component";

export default class Ascending extends Vue {}
